<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="label"
    selectLabel=""
    selectedLabel="«"
    v-b-popover.hover="$t(msg)"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'localidadeWebSelecionada',
    'id_localidade'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false,
      msg: ''
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_template_metodo_pagamento', null);
        return;
      }
      this.$emit('selectChange', 'id_template_metodo_pagamento', e.id);
      this.$emit('focus');
    },
    label({ nome }) {
      return nome;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;

      if (!this.id_localidade) {
        return;
      }

      this.$api
        .search('business/localidade/templatempByLocation', {
          id_localidade: this.id_localidade
        })
        .then((data) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(data);
          this.setValue(this.nameField);
          this.isLoading = false;
          if (!data?.length) {
            this.msg = 'Não foram encontrados templates para a localidade atual';
          } else {
            this.msg = '';
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Atenção'),
            text: this.$i18n.t('Não foi possível carregar os métodos de pagamento')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    id_localidade() {
      this.setOptions();
    }
  }
};
</script>

<style lang="scss" scoped></style>
